import { TUrlParameters } from '@ConfigLoader/Configs/ConnectionConfig';
import { TCreditionals } from '@Services/HttpService/HttpService.types';
import { v4 as uuidv4 } from 'uuid';

export default function AuthCreditionalCheck(mandatoryUrlParams: Array<string>, data: TUrlParameters) {
    let checkPass = false;
    const missingFields: Array<string> = [];
    const creditionals = {} as TCreditionals;

    mandatoryUrlParams.forEach((key: string) => {
        if (data.hasOwnProperty(key)) {
            creditionals[key] = data[key];
        } else {
            missingFields.push(key);
        }
    });

    checkPass = missingFields.length > 0 ? false : true;

    if (data.playerId) {
        creditionals.playerId = data.playerId;
    } else {
        creditionals.playerId = 'demo_' + uuidv4();
    }

    if (data.isDemoPlay && (creditionals.playerId === 'demo' || creditionals.playerId === 'demouser')) creditionals.playerId = 'demo_' + uuidv4();
    if (data.isDemoPlay && !creditionals.casinoTempToken) checkPass = true;

    creditionals.params = {};
    creditionals.clientPlatform = data.clientPlatform ? data.clientPlatform : 'web';
    creditionals.clientType = data.clientType ? data.clientType : 'casino';
    creditionals.params.isInternalPlayer = data.isInternalPlayer !== undefined ? data.isInternalPlayer : false;

    if (data.countryCode) creditionals.params.countryCode = data.countryCode;

    return {
        checkPass: checkPass,
        missingFields: missingFields,
        creditionals: creditionals
    };
}
